import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';
import { ModalOptions } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'custom-clear-cart',
  templateUrl: './custom-clear-cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@GenerateLazyComponent()
export class CustomClearCartComponent implements OnInit {
  options: ModalOptions;

  constructor(private checkoutFacade: CheckoutFacade, private translate: TranslateService) {}

  ngOnInit(): void {
    this.options = {
      titleText: this.translate.instant('dias.shopping_cart.clear_alldialog.header'),
      rejectText: this.translate.instant('dias.shopping_cart.clear_all.cancel.label'),
      confirmText: this.translate.instant('dias.shopping_cart.clear_all.confirm.label'),
    };
  }

  deleteBasket() {
    this.checkoutFacade.deleteBasket();
  }
}
